import { i18n } from 'i18n';
import { TLabelValue } from 'shared/typings';

export const TRANSACTION_STATUSES = {
	need_to_paid: i18n.t('Need to paid'),
	paid: i18n.t('Paid'),
};

export const TRANSACTION_STATUSES_OPTIONS: TLabelValue[] = Object.entries(TRANSACTION_STATUSES).map(([key, value]) => ({
	value: key,
	label: value,
}));
